import Cookies from 'js-cookie'

const viewElement = document.getElementsByName('view');

if (viewElement.length > 0) {

	viewElement.forEach((number, i) => {

		viewElement[i].addEventListener('click', () => {
			if (viewElement[i].value == 'list') {
				window.location.href = pageUrlList;
			}
			if (viewElement[i].value == 'calendar') {
				window.location.href = pageUrlCalendar;
			}
			if (viewElement[i].value == 'map') {
				window.location.href = pageUrlMap;
			}
			// Cookies.set('eventView', viewElement[i].value);
		});

	})
}
